import { Component, OnDestroy, OnInit } from "@angular/core";
import { Select } from "@ngxs/store";
import { Observable, Subscription } from "rxjs";
import { FirebaseUser } from "./interface/user";
import { UserState } from "./states/user.state";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.less"],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  @Select(UserState.firebaseUser) firebaseUser: Observable<FirebaseUser>;

  loading = false;
  private themeSub?: Subscription;

  ngOnInit(): void {
    this.applyTheme(localStorage.getItem("theme") === "dark");

    this.themeSub = this.firebaseUser.subscribe((fb) => {
      const darkMode = !!fb?.AppUser?.darkMode;
      this.applyTheme(darkMode);
      localStorage.setItem("theme", darkMode ? "dark" : "light");
    });
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }

  private applyTheme(darkMode: boolean): void {
    if (typeof document === "undefined") return;
    document.body.classList.toggle("theme-dark", darkMode);
  }
}
